import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';
import { getCountryCodeFromPhone } from './getCountryCodeFromPhone';
import { normalizePhoneNumber } from './normalizePhoneNumber';
import { hasInternationalPhonePrefix } from './hasInternationalPhonePrefix';

const getString = (value: unknown): string | undefined =>
    typeof value === 'string' && value.trim() ? value.trim() : undefined;

const detectCountryCodeFromPhone = (
    phone?: string
): ECountryCode | undefined => {
    if (!phone) return undefined;

    const digitsOnly = normalizePhoneNumber(phone).replace(/\D/g, '');
    if (!digitsOnly || !hasInternationalPhonePrefix(digitsOnly)) return undefined;

    return getCountryCodeFromPhone(digitsOnly);
};

export type TResolvedNormalizedPhone = {
    phone?: string;
    countryCode?: ECountryCode;
};

/**
 * Resolves contact.normalizedPhone (E.164 string, e.g. +5215512345678).
 */
export const parseNormalizedPhone = (
    value: unknown
): TResolvedNormalizedPhone => {
    const phone = getString(value);
    if (!phone) return {};

    return {
        phone,
        countryCode: detectCountryCodeFromPhone(phone),
    };
};
